import { KYMW1409Model } from '../kymw1409.model';
import { MarkListModel } from '../../kymw1400/vo/mark-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * マークリストを取得する。
 *
 * @export
 * @class GetMarkListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetMarkListService extends PlessJsonResponderSub<any> {

  private model: KYMW1409Model = null;
  private vo: MarkListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMarkListService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.pCodeList.map(pCode => {
      const ogfi = (this.vo.orderGoodsFlgKoma as Array<any>).find(ogfi => ogfi.PCode == pCode);
      return {
        condition: {
          PCode: pCode,
          ReceiptSOrderCode: ogfi.ReceiptSOrderCode,
          OrderNum6Digits: ogfi.OrderNum6Digits,
          ItemCode: ogfi.ItemCode,
          OrderGoodsFlg: ogfi.OrderGoodsFlg,
        }
      }
    });

    return new PlessRequest({
      search: {
        Mark: {
          condition: {
            OrderCode: this.vo.orderCode,
            CoopCode: this.vo.coopCode,
            OrderGoodsFlg: this.vo.orderGoodsFlg
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1409Model} model
   * @param {MarkListModel} vo
   * @memberof GetMarkListService
   */
  execute(model: KYMW1409Model, vo: MarkListModel) {
    this.model = model;
    this.vo = vo;
    this.send('getMarkList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMarkListService
   */
  success(data: any) {
    // マークグループコンボボックスの編集
    this.model.setMarkGroupList(data);
    // 結果データの編集
    this.model.updateServerResponse(data);
  }
}
